import React, { createContext, useContext } from 'react';

interface ChatContextType {
    openChat: () => void;
    openSpecificChat: (chatId: number) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (!context) {
        throw new Error('useChatContext must be used within a ChatProvider');
    }
    return context;
};

interface ChatProviderProps {
    children: React.ReactNode;
    openChat: () => void;
    openSpecificChat: (chatId: number) => void;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({
    children,
    openChat,
    openSpecificChat
}) => {
    return (
        <ChatContext.Provider value={{ openChat, openSpecificChat }}>
            {children}
        </ChatContext.Provider>
    );
};